import React, { useEffect } from "react";
import HeroSection from "../Components/HeroSection";
import About from "../Components/About";
import SectionFour from "../Components/SectionFour";
import Faqs from "../Components/Faqs";
import SectionFive from "../Components/SectionFive";
import TokenSection from "../Components/TokenSection";
import PresaleStorySections from "../Components/PresaleStorySections";
import { useLocation } from "react-router-dom";
import RoadMapSection from "../Components/roadMapSection";

const scrollToSectionWithOffset = (id, offset = 100) => {
  const section = document.getElementById(id);
  if (section) {
    if (id === "presale-buy-action") {
      section.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    const y = section.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   if (location.hash) {
  //     const id = location.hash.replace("#", "");
  //     const element = document.getElementById(id);
  //     if (element) {
  //       setTimeout(() => {
  //         element.scrollIntoView({ behavior: "smooth" });
  //       }, 100);
  //     }
  //   }
  // }, [location]);

  // useEffect(() => {
  //   const scrollToId = location.state?.scrollToId || location.hash.replace("#", "");
  //   console.log("scrollToIdscrollToId",scrollToId)
  //   if (scrollToId) {
  //     const offset = 100;
  //     const section = document.getElementById(scrollToId);
  //     if (section) {
  //       const y = section.getBoundingClientRect().top + window.pageYOffset - offset;
  //       window.scrollTo({ top: y, behavior: "smooth" });
  //     }
  //   }
  // }, [location]);

  useEffect(() => {
    const scrollToId =
      location.state?.scrollToId || location.hash.replace("#", "");

    if (scrollToId) {
      const interval = setInterval(() => {
        const section = document.getElementById(scrollToId);
        if (section) {
          clearInterval(interval);
          scrollToSectionWithOffset(scrollToId, 100);
        }
      }, 100);

      setTimeout(() => clearInterval(interval), 3000);
    }
  }, [location]);

  return (
    <div className="main-landing-page">
      <section id="hero">
        <HeroSection />
      </section>
      <section id="about">
        <About />
      </section>
      <PresaleStorySections />
      <section id="tokenomics">
        <TokenSection />
      </section>
      <section id="wallets">
        <SectionFour />
      </section>
      <section id="roadmap">
        <RoadMapSection />
      </section>
      <section id="faqs">
        <Faqs />
        <SectionFive />
      </section>
    </div>
  );
}

export default LandingPage;
